import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=5e9a098c&scoped=true&"
import script from "./Tickets.vue?vue&type=script&lang=ts&"
export * from "./Tickets.vue?vue&type=script&lang=ts&"
import style0 from "./Tickets.vue?vue&type=style&index=0&id=5e9a098c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9a098c",
  null
  
)

export default component.exports